import Seo from "../components/Seo";
import { PageHero } from "../components/common/Section";
import { LEGAL } from "../data/legal";

export default function Legal({ slug }) {
  const page = LEGAL[slug];
  return (
    <>
      <Seo title={page.title} path={`/${slug}`} />
      <PageHero eyebrow="Legal" title={page.title} text={page.intro} />
      <section className="py-20">
        <div className="container-q max-w-4xl space-y-12" data-testid={`legal-${slug}`}>
          {page.sections.map(([h, items]) => (
            <div key={h}>
              <h2 className="text-2xl font-bold text-navy">{h}</h2>
              <ul className="mt-4 space-y-3">
                {items.map((t) => <li key={t} className="flex gap-3 text-slate-600"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-gold" />{t}</li>)}
              </ul>
            </div>
          ))}
          <p className="text-sm text-slate-500">Last updated: {new Date().getFullYear()}. Questions? Write to info@quantora.co.in.</p>
        </div>
      </section>
    </>
  );
}
